__turbopack_context__.v({
  "hr": "M9_Euq_hr",
  "title": "M9_Euq_title",
  "triggerWrapper": "M9_Euq_triggerWrapper",
});
